import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { JustificationDialogService } from './justification-dialog.service';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { IJustificationModel } from './justification-dialog.model';
import {MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../material.module';
import { SpinnerService } from '../../core';

@Component({
    selector: 'app-justification-dialog',
    imports: [ReactiveFormsModule, MaterialModule],
    templateUrl: './justification-dialog.component.html',
    styleUrls: ['./justification-dialog.component.scss'],
    providers: [JustificationDialogService]
})
export class JustificationDialogComponent{
  private justificationService = inject(JustificationDialogService);
  private fb = inject(FormBuilder);
  public dialogRef= inject(MatDialogRef<JustificationDialogComponent>);
  spinnerService = inject(SpinnerService);

  description: string[] = localStorage.getItem("AutomatedTransfersScreenJustificationPopup")==='true' ? ["A new version of existing file(s) have been identified.","Please add a comment and confirm the action."] : ["The action requires an additional justification.","Please add a comment and confirm the action."];

  justificationForm = this.fb.group({
    justificationCode: this.fb.control("",[Validators.required]),
    justificationComment: this.fb.control("",[Validators.required, Validators.minLength(10), Validators.maxLength(500)])
  });

  readonly masterData = toSignal(this.justificationService.GetJustificationMasterData(), { initialValue: [] as IJustificationModel[] });
  
  getJustificationComment(justificationCode: string): void {
    this.spinnerService.show(true);
    const data = this.masterData();
    if (data?.length) {
      const comment = data.find(x => x.Key === justificationCode)?.Value;
      if (comment !== undefined) {
        this.justificationForm.get('justificationComment').patchValue(comment);
      }
    }
    this.spinnerService.show(false);
  }

  confirm():void{
    let comments:string = this.justificationForm.get('justificationComment')?.value ?? null;
    let justificationCode = this.justificationForm.get('justificationCode')?.value ?? null;
    if(comments && comments.length >= 10 && comments.length <=500 && justificationCode){
      this.dialogRef.close({comment:comments});
    }
  }

  cancel():void{
    this.dialogRef.close();
  }

  public buildJustificationDialogId(controlId: string): string {
    return `justification-dialog-${controlId}`;
  }
}
